export default "__VITE_ASSET__23b1d952__"